import {getLocalDateISO} from "../helpers";

export interface readySignedConsentDataType {
  title: string
  data_composition: string
  sign_local_at: string
  source: string
}

export type readySignedConsentsRecordTyped =  Record<"consent" | "policy" | "notification_consent", ()=>readySignedConsentDataType>

export const readySignedConsentsData: readySignedConsentsRecordTyped = {
  consent: ()=>{
    return {
      title: "СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      data_composition: "имя, фамилия, отчество; дата рождения; данные паспорта или иного документа, " +
          "удостоверяющего личность; адрес регистрации; адрес электронной почты; номер телефона; банковские реквизиты.",
      source:"https://prohorovaconsult.com/consent",
      sign_local_at: getLocalDateISO()
    }
  },
  policy: ()=>{
    return {
      title: "Политика в отношении обработки персональных данных пользователей сайта",
      data_composition: "имя, фамилия, отчество; дата рождения; данные паспорта или иного документа, " +
          "удостоверяющего личность; адрес регистрации; адрес электронной почты; номер телефона; банковские реквизиты.",
      source:"https://prohorovaconsult.com/policy",
      sign_local_at: getLocalDateISO()
    }
  },
  notification_consent: ()=>{
    return {
      title: "СОГЛАСИЕ НА ПОЛУЧЕНИЕ РАССЫЛКИ (ЭЛЕКТРОННЫХ СООБЩЕНИЙ)",
      data_composition: "имя, фамилия, отчество, никнейм и ID в мессенджере, " +
          "адрес электронной почты, контактный номер телефона",
      source:"https://prohorovaconsult.com/notification-consent",
      sign_local_at: getLocalDateISO()
    }
  },

}
